// extracted by mini-css-extract-plugin
export default {"root":"yn4rK3av"};